'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=require('./createColorPalette'),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var cherry={1:'#f54250',2:'#cc313d',3:'#510006'};exports.default=(0,_createColorPalette2.default)(cherry,'cherry');


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/colors/cherry.js
 **/